module.exports = __webpack_public_path__ + "img/本月收益.0856d941.png";